module.exports = __webpack_public_path__ + "img/greensmiley.088a130c.png";